import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import {User} from '../user/user';
import { AuthService } from '../shared/auth/auth.service';
import { ToastrService } from 'ngx-toastr';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { WebServiceService } from 'app/web-service.service';
import { first } from 'rxjs/operators';

@Component({
    moduleId: module.id,
    templateUrl: 'login.component.html'
})

export class LoginComponent implements OnInit {
    model=  <User>{};
    loading = false;
    returnUrl: string;
    loginForm : FormGroup;
    userDetails : any;
    loginData : any;
    message : any;
    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private _formBuilder: FormBuilder,
        private authenticationService: AuthService,
        private toastrService: ToastrService,
        private service : WebServiceService
    ) { }
  
    initializeData(){
        this.loginForm = this._formBuilder.group({
            email: ['', [Validators.required,Validators.email]],
            password: ['', Validators.required]
        });
    }
    loginTrim(evt){
        console.log(evt.code,"evt");
        let email=evt.replace(' ','');
        this.loginForm.controls["email"].setValue(email); 
    }
                    //  Validators.email,Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$')]],
    get f() { return this.loginForm.controls; }
    // get isEmailMismatch() { return this.loginForm.getError('emailMismatch')}

    ngOnInit() {
        // reset login status
        // this.authenticationService.logout();
        this.initializeData();
        // get return url from route parameters or default to '/'
        // this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
    }
   
    login(loginForm){
        // console.log(loginForm.value.email.replace(' ',''),loginForm.value.email.trim());
        this.userDetails = {
            'email' : loginForm.value.email,
            'password' : loginForm.value.password,
            // 'b2c':false
        };
        if(loginForm.valid){
            this.service.httpLoginPost('login',this.userDetails).subscribe((result:any)=>{
                this.loginData = JSON.stringify(result.data);
                sessionStorage.setItem('currentUser',this.loginData);
                if(result.success==true){
                    this.toastrService.success('Logged in Successfully')
                    var token={
                        "token":result.data['Auth-token']
                    }
                    this.service.httpLoginPost('login/token/validate',token).subscribe((result1:any)=>{
                   if(result1.success){

                    this.service.httpGet('booking/max/ticket/count').subscribe((result: any) => {
        
                        this.service.setbookingCount(result.data);
                        sessionStorage.setItem('count',result.data)
                          })
                    
                    this.router.navigateByUrl('/home');
                    
                   }
                });
                }
               
            })
        }else if(loginForm.value.email!='' && loginForm.value.password!=''){
            this.toastrService.error("Please Enter the Valid Email and Password")
            
        }else if(loginForm.value.email!=''){
            this.toastrService.error("Please Enter the Password")
            
        }else if(loginForm.value.password!=''){
            this.toastrService.error("Please Enter the Email")
            
            
        }else{
            this.toastrService.error("Please Enter the Email and Password")
            // this.toastrService.error("Invalid Userid or Password, Please try with different credentials");
        }

    }


    redirectTo(url){
        window.open(url);
    }

    forgotPWD(loginForm){
        if(loginForm.value.email){
            let logindata= {
                email:loginForm.value.email,
                baseUrl: location.origin
            //baseUrl: 'https://b2b.rutwa.ae'
            }
            
     //   this.service.httploginGet('forgot/password/mail?userMail='+loginForm.value.email).subscribe((data:any)=>{
        this.service.httpLoginPost('forgot/password/mail',logindata).subscribe((data:any)=> {
            if(data.success) {
     this.toastrService.success(data.message);
            } 
        }) 
    }else{
        this.toastrService.error("Please Enter the Email");
    }
    }
 
}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts